import { Box } from '../box/box';
import { CircularProgress } from '../circular-progress/circular-progress';

export const Loader = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%',
        width: '100%',
      }}
    >
      <Box
        p={4}
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    </Box>
  );
};
